import type { PayingOrganization } from '@/types/payingOrganization';

import { apiClient } from '../apiClient';

export const PATHS = {
  PAYING_ORGANIZATION: (webserverOrgUuid: string) =>
    `/api/v3/payingorganization/${webserverOrgUuid}/`,
} as const;

// GET /api/v3/payingorganization/{uuid} returns a single-element array
// (Tastypie-style), mirroring Sparta's `getPayingOrganization`. Returns the
// org (camelized by the apiClient interceptor) or undefined when absent.
export async function getPayingOrganization(
  webserverOrgUuid: string
): Promise<PayingOrganization | undefined> {
  const res = await apiClient.get<PayingOrganization[]>(
    PATHS.PAYING_ORGANIZATION(webserverOrgUuid)
  );
  return Array.isArray(res.data) ? res.data[0] : undefined;
}
